export default class boxModuleDisposicao {

    constructor(stateUtil, boxesModules) {
        this._stateUtil = stateUtil;
        this._boxesModules = boxesModules;
    }

    _stateUtil = null;

    _boxesModules = null;

    //quando reorganiza a ordem dos objetos
    visBoxReordenaBoxes(){
        //reordena o array pelo idx
        this._stateUtil.ordenaBoxes()

        //garante valores corretos
        let idx = 0;
        this._boxesModules.boxes.value.forEach(b => {
            this._stateUtil.setIdx(b, idx++, 1, true)
        });

        //evento
        //state.objetosReordenados = state.objetosAlterados = { id: null, handler: Math.random() };
    }

    //so deve ser chamado pelo action
    visBoxSetDisposicao(tipo) { // {origem: idx, dest: idx }
        let _this = this;
        if (!this._boxesModules.boxes.value.length || !this._boxesModules.boxes.value.filter(b => {
                return b.state.selected
            }).length) {
            //console.log('~@@@nenhum objeto selecionado');
            return;
        }

        //cópia do estado de seleção atual dos objetos em um array independente
        let tempBoxes = this._stateUtil.getBoxesSelected().slice();
        let ultimoIdxDosSelecionados = tempBoxes[tempBoxes.length-1].idx; //ultimo idx dos selecionados
        let primeiroIdxDosSelecionados = tempBoxes[tempBoxes.length-1].idx; //primeiro idx dos selecionados

        ////pega o pai.. todos os selecionados sao do mesmo pai, dai pega o pai do primeiro
        let idxParent = tempBoxes[0].parent.idx;
        let idxTab = tempBoxes[0].parent.idxTab;

        //pega todos os filhos do mesmo pai, todo mundo do mesmo nivel dos selecioandos, incluindo os selecionados.. todos no nivel
        var tempBoxesNoNivel = this._boxesModules.boxes.value.filter(b => b.parent.idx == idxParent && b.parent.idxTab == idxTab);

        let toIndex = -1;
        switch (tipo) {
            case 'UP':
                {
                    //descobrir qual o proximo no nivel
                    
                    let idx = tempBoxesNoNivel.indexOf(tempBoxesNoNivel.filter(b => b.idx == ultimoIdxDosSelecionados)[0]); //indice do ultimo selecionado nos boxes do nivel
                    if (tempBoxesNoNivel[idx+1])
                        toIndex = tempBoxesNoNivel[idx+1].idx;
                    else
                        return; //nao tem proximo nivel
                }

                break;
            case 'DOWN':
                {
                    //descobrir qual o anterior no nivel
                    let pos = tempBoxesNoNivel.indexOf(tempBoxesNoNivel.filter(b => b.idx == primeiroIdxDosSelecionados)[0]); //indice do ultimo selecionado nos boxes do nivel
                    if (tempBoxesNoNivel[pos-1]) {
                        toIndex = tempBoxesNoNivel[pos-1].idx;
                    }
                    else
                        return; //nao tem nivel anterior
                }
                break; 
            case 'TOP':
                toIndex = tempBoxesNoNivel[tempBoxesNoNivel.length-1].idx;
                break;                
            case 'BOTTOM':
                toIndex = tempBoxesNoNivel[0].idx
                break;
        }

        if (!tempBoxesNoNivel.filter(b => b.idx == toIndex).length)
        {
            return; //nao existe o destino
        }

        function dePara(fromIndex, toIndex) {
            if (fromIndex == toIndex)
                return;

            let from = Math.min(fromIndex, toIndex);
            let to = Math.max(fromIndex, toIndex);

            tempBoxes.forEach((b)=> {
                if (b.idx < from)
                    return;
                if (b.idx > to)
                    return;

                let posicao = 1;
                if (toIndex < fromIndex)
                    posicao *= -1; //troca o sinal

                _this._stateUtil.setIdx(b, toIndex + ((b.idx+1)/100 * posicao), 1);
            })
        }

        let ordemReversa = [] //pega a ordem reversa do posicionamento e adiciona a pilha de refazer
        tempBoxes.forEach((box) => {
            //console.log(box);
            ordemReversa.push({ box: box, to: box.idx, from: toIndex })
            console.show(`de: ${box.idx}  para: ${toIndex}`);
            dePara(box.idx, toIndex);
        })
        this._boxesModules.undoStack.value.push({type: 'order', estrutura: ordemReversa})
    }

    reverterOrdem(move){

        var box = this._boxesModules.boxes.value.filter(b => b.id == move.box.id)[0]
        let _this = this;
        function dePara(fromIndex, toIndex) {
            if (fromIndex == toIndex)
                return;

            let from = Math.min(fromIndex, toIndex);
            let to = Math.max(fromIndex, toIndex);

            if (box.idx < from)
                return;
            if (box.idx > to)
                return;

            let posicao = 1;
            if (toIndex < fromIndex)
                posicao *= -1; //troca o sinal

            _this._stateUtil.setIdx(box, toIndex + ((box.idx + 1) / 100 * posicao), 1);
            
        }

        dePara(move.from, move.to);
    }

}